module.exports = __webpack_public_path__ + "images/dg_phone-bd26fe9693783cb3a04cf9da773beacd.png";